/**
 * Settle the cart queue and gift reconcile on checkout intent, so nobody
 * navigates to checkout mid-mutation. Display only, no prefetch, no prerender.
 */
(function () {
  if (window.__SC_CHECKOUT_PREWARM__) return;
  window.__SC_CHECKOUT_PREWARM__ = true;

  var SELECTOR = 'button[name="checkout"], [name="checkout"], .cart__checkout';
  var COOLDOWN_MS = 2500;
  var HOVER_DWELL_MS = 80;
  var lastRun = 0;
  var hoverTimer = null;

  function settleCart(source) {
    var now = Date.now();
    if (now - lastRun < COOLDOWN_MS) return;
    lastRun = now;
    if (typeof window.SC_reconcileGiftsIdle === 'function') {
      window.SC_reconcileGiftsIdle(source);
    } else if (typeof window.SC_getSharedCart === 'function') {
      window.SC_getSharedCart({ forceFresh: true }).catch(function () {});
    }
  }

  function isCheckout(target) {
    return target && target.closest && target.closest(SELECTOR);
  }

  document.addEventListener('pointerover', function (e) {
    if (!isCheckout(e.target)) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { settleCart('checkout-hover'); }, HOVER_DWELL_MS);
  }, { capture: true, passive: true });

  document.addEventListener('pointerout', function (e) {
    if (isCheckout(e.target)) clearTimeout(hoverTimer);
  }, { capture: true, passive: true });

  document.addEventListener('pointerdown', function (e) {
    if (isCheckout(e.target)) settleCart('checkout-pointerdown');
  }, { capture: true, passive: true });

  document.addEventListener('touchstart', function (e) {
    if (isCheckout(e.target)) settleCart('checkout-touchstart');
  }, { capture: true, passive: true });
})();
